import { AxiosError } from 'axios';
import { cloneDeep } from 'lodash';
import { Component, Prop } from 'vue-property-decorator';
import AbstractFilterMultiple from '@/components/CustomFilter/AbstractFilterMultiple';
import { FilterInterface } from '@/components/CustomFilter/FilterInterface';

@Component
export default class AbstractFilterMultipleModel extends AbstractFilterMultiple implements FilterInterface {

  // #region @Props

  @Prop()
  protected model!: any;

  // #endregion

  // #region API Requests

  protected async getItems(filter: string = '') {
    this.items = await this.$storage.remember<any[]>(`${this.filtersStorageKey}_${this.filterStorageKey}_${filter}`, async () => {
      await cloneDeep(this.model)
        .filter('search', filter)
        .all()
        .then((items: any[]) => {
          this.items = items;
        })
        .catch((error: AxiosError) => {});

      return this.items;
    })
  }

  // #endregion
}
